import { defineStore } from 'pinia';
import { RateType } from '@/connect';
import { useLocalStorageNumber } from '@/modules/common/composables/storage';

export const useRateTypeStore = defineStore('rate-type', () => {
  const marketplaceRateType = useLocalStorageNumber<RateType>(
    'Marketplace_RateType',
    RateType.REBATE
  );

  const ordersUploadRateType = useLocalStorageNumber<RateType>(
    'OrdersUpload_RateType',
    RateType.REBATE
  );

  return {
    marketplaceRateType,
    ordersUploadRateType,
  };
});

export type RateTypeStore = ReturnType<typeof useRateTypeStore>;
